export default {
   zIndexes: {
      dateRangePicker: 100000,
      drawerMenu: 91,
      globalNav: 2,
      htmlEditor: 20000,
      locationAutocompletePicker: 100000,
      mediaOptionsPopover: 20000,
      notificationManager: 20000,
      orgContextFatalErrorMessage: 10000000,
      singleDatePicker: 100000,
      timePicker: 100000,
      tmpSettingsModal: 10001
   }
}
